import { connect } from "@permaweb/aoconnect"

import ENV from "@/env"

const arIoCu = connect({
  CU_URL: "https://cu.ar-io.dev",
})

export async function getPrimaryName(address: string): Promise<string> {
  const result = await arIoCu.dryrun({
    process: ENV.VITE_ARNS_AR_IO_REGISTRY,
    tags: [
      { name: "Action", value: "Primary-Name" },
      { name: "Address", value: address },
    ],
  })

  if (result.Messages.length === 0) throw new Error("No response from Primary-Name")

  const message = result.Messages[0]
  const name = message.Tags.find((x: any) => x.name === "Name")?.value

  return name
}
